import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
    selector: 'vui-data-grid-context',
    templateUrl: './data-grid-context.component.html',
    styleUrls: ['./data-grid-context.component.scss']
})
export class DataGridContextComponent implements OnInit {
    private _loaded: boolean;

    constructor() {
    }

    ngOnInit() {

    }

    public get loaded(): boolean {
        return this._loaded;
    }

    @HostBinding('class.loaded') @Input()
    public set loaded(loaded) {
        setTimeout(() => {
            this._loaded = loaded;
        }, 500);
    }
}
